import React, { useEffect, useState } from 'react'
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Form, Space, Tag, Tooltip } from 'antd'
import get from 'lodash.get'
import {
  ACTION_MODE,
  OPTIONS_OBJECT_POST,
  OPTIONS_PACKAGE_POST,
  PAGE_SIZE_OPTIONS
} from '../../configData'
import {
  deletePakagePost,
  getPakagePost,
  pakagePostAdd,
  pakagePostDetail,
  pakagePostUpdate
} from '../../services/pakage-post'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import FilterForm from './FilterForm'
import FormPost from './FormPost'
import {
  deleteSlideImage,
  getSlideImage,
  slideImageAdd,
  slideImageUpdate
} from '../../services/slide-service'
import { hasPermission } from '../../config-func'
import { Modal } from 'antd'
import Loading from '../Loading'

const TYPE_OPTIONS = [
  {
    value: 1,
    name: 'Nội bộ',
    label: 'Nội bộ'
  },
  {
    value: 2,
    name: 'Cộng đồng',
    label: 'Cộng đồng'
  }
]

const DISPAY_OPTIONS = [
  {
    value: 'Mobile',
    name: 'Mobile',
    label: 'Mobile'
  },
  {
    value: 'Web',
    name: 'Web',
    label: 'Web'
  }
]

const DISPAY_POSITION_OPTIONS = [
  {
    value: 'Diamond',
    name: 'Diamond',
    label: 'Diamond'
  },
  {
    value: 'Diamond2',
    name: 'Diamond2',
    label: 'Diamond2'
  },
  {
    value: 'Gold',
    name: 'Gold',
    label: 'Gold'
  },
  {
    value: 'Silver',
    name: 'Silver',
    label: 'Silver'
  },
  {
    value: 'Bronze',
    name: 'Bronze',
    label: 'Bronze'
  },
  {
    value: 'Sell',
    name: 'BDS Bán',
    label: 'BDS Bán'
  },
  {
    value: 'Lease',
    name: 'BDS Thuê',
    label: 'BDS Thuê'
  },
  {
    value: 'Buying',
    name: 'BDS Tìm mua',
    label: 'BDS Tìm mua'
  },
  {
    value: 'Renting',
    name: 'BDS Tìm thuê',
    label: 'BDS Tìm thuê'
  },
  {
    value: 'Project',
    name: 'Dự án',
    label: 'Dự án'
  }
]
const SlideImage = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState('')

  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
  })

  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    let _total = 0

    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      is_public: true
      // name: filters.name || '',
      // status: filters.status || '',
      // type: filters.type || ''
    }

    // const cleanedData = Object.fromEntries(
    //   Object.entries(params).filter(
    //     ([_, value]) => value !== '' && value !== null && value !== undefined
    //   )
    // )

    try {
      const response = await getSlideImage(params)
      _total = response?.data?.total
      _dataSource = response?.data?.list
      // }
    } catch (error) {
      openNotification(
        'error',
        error?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
      setTotal(_total)
      setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },
    {
      title: 'Ảnh',
      dataIndex: 'image_url',
      key: 'image_url',
      render: (url) => <ImageWithFallback src={url} />
    },
    {
      title: 'Loại',
      dataIndex: 'type',
      key: 'type',
      render: (_, record) => {
        return (
          <div>
            {TYPE_OPTIONS.find((item) => item.value === record.type)?.name ||
              ''}
          </div>
        )
      }
    },
    {
      title: 'Vị trí hiển thị',
      dataIndex: 'display_position',
      key: 'display_position',
      render: (_, record) => {
        console.log('record: ', record)
        return (
          <Space size="small">
            {record?.display_on?.toUpperCase() === 'MOBILE'
              ? record?.display_order
              : record?.display_position}
          </Space>
        )
      }
    },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 200,
      render: (_, record) => {
        return (
          <Space size="small">
            <>
              {hasPermission('P61.2', permissions) && (
                <Tooltip title="Chỉnh sửa">
                  <Button
                    style={{ width: 32 }}
                    icon={<EditOutlined />}
                    onClick={() => {
                      console.log('record', record)
                      setIsModalOpen(true)
                      setMode(ACTION_MODE.UPDATE)
                      form.setFieldsValue(record)
                    }}
                  />
                </Tooltip>
              )}
              {hasPermission('P61.3', permissions) && (
                <Tooltip title="Xoá">
                  <Button
                    style={{ width: 32 }}
                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() =>
                      showConfirm({
                        title: 'Xác nhận xóa',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn xóa <b>{record.name}</b>
                          </div>
                        ),
                        onOk: () => handleDelete(record)
                      })
                    }
                  />
                </Tooltip>
              )}
            </>
          </Space>
        )
      }
    }
  ]

  // Component hiển thị ảnh với fallback text
  const ImageWithFallback = ({ src }) => {
    const [error, setError] = useState(false)

    return error ? (
      <span style={{ color: 'red', fontSize: 14 }}>Không có ảnh</span>
    ) : (
      <img
        src={src}
        alt="Ảnh"
        style={{
          width: 70,
          height: 70,
          objectFit: 'cover',
          borderRadius: 8,
          cursor: 'pointer'
        }}
        onError={() => setError(true)}
        onClick={() => {
          setPreviewImage(src)
          setPreviewVisible(true)
        }}
      />
    )
  }

  // Thêm sửa project
  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()

      const { image_url, image_url_mobile, id, ...data } = values

      const body = {
        ...data,
        display_order:
          data?.display_on?.toUpperCase() === 'MOBILE'
            ? data?.display_order
            : 0,
        type: data?.type ?? 1,
        files: [image_url],
        image_url_mobile:
          data?.display_on?.toUpperCase() === 'WEB' ? image_url_mobile : ''
      }
      const res =
        mode == ACTION_MODE.ADD
          ? await slideImageAdd(body)
          : await slideImageUpdate(body, id)
      if (res?.message) {
        form.resetFields()
        setIsModalOpen(false)
        fetchData()
        openNotification(
          'success',
          mode == ACTION_MODE.ADD ? 'Tạo thành công !' : 'Cập nhật thành công !'
        )
      } else {
        openNotification('error', 'Đã có lỗi xảy ra')
      }
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  // Xóa
  const handleDelete = async (record) => {
    const body = {
      image_url: record.image_url
    }
    setLoading(true)
    try {
      const res = await deleteSlideImage(body, record.id)
      fetchData()
      openNotification('success', res.message)
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  //
  return (
    <div>
      <Loading loading={loading} />
      {/* <Card className="mb-2">
        <FilterForm
          handleSearch={handleSearch}
          setFilters={setFilters}
          fetchData={fetchData}
        />
      </Card> */}

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            {hasPermission('P61.1', permissions) && (
              <Button
                type="primary"
                onClick={() => {
                  setIsModalOpen(true)
                  setMode(ACTION_MODE.ADD)
                }}
              >
                <PlusOutlined />
                Thêm mới
              </Button>
            )}
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>

      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa Slide Ảnh thông báo Nội bộ + Cộng đồng'
            : mode == 'ADD'
            ? 'Thêm mới Slide Ảnh thông báo Nội bộ + Cộng đồng'
            : 'Xem chi tiết'
        }
        visible={isModalOpen}
        centered
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={mode == 'VIEW' ? [''] : ''}
        width={600}
      >
        <FormPost
          form={form}
          mode={mode}
          type={TYPE_OPTIONS}
          displayOptions={DISPAY_POSITION_OPTIONS}
          displayOn={DISPAY_OPTIONS}
        />
      </ModalCustom>

      {/* Modal xem ảnh */}
      <Modal
        visible={previewVisible}
        title={null}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        centered
      >
        <img alt="example" style={{ width: '100%' }} src={previewImage} />
      </Modal>

      <ModalConfirm />
    </div>
  )
}

export default SlideImage
